<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/oneByOneClassList'}">1对1班级</el-breadcrumb-item>
      <el-breadcrumb-item>排课</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>课程信息</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData">
          <el-row :gutter="24">
            <el-col :span="12">
              <!-- 关键修复：添加自定义类名确保样式生效 -->
              <el-form-item label="选择课程" prop="courseId" class="course-form-item">
                <!-- flex布局容器（修复：增加类名，通过样式强制生效） -->
                <div class="course-select-wrapper">
                  <el-select
                    v-model="fromData.courseId"
                    @change="getTeacher(fromData.courseId)"
                    placeholder="请选择课程"
                    ref="courseSelect">
                    <el-option
                      v-for="item in courseList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- 新建课程按钮（修复：调整宽度，确保不换行） -->
                  <el-button
                    type="primary"
                    size="mini"
                    @click="openCourseModal">
                    新建课程
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="班级名称" prop="className">
                <el-input v-model="fromData.className" placeholder="默认使用课程名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="上课教室" prop="classRoom">
                <el-input v-model="fromData.classRoom" placeholder="请输入上课教室"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单课时长(分钟)" prop="longTimeOf">
                <el-input v-model="fromData.longTimeOf" placeholder="单课时长为5的倍数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="扣除课次类型" prop="deductType">
                <el-select v-model="fromData.deductType" placeholder="请选择">
                  <el-option
                    v-for="item in deductTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="扣除课次数量" prop="deductTimes">
                <el-input-number v-model="fromData.deductTimes" :min="1" :max="3"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="授课老师" prop="teacherId">
                <el-select v-model="fromData.teacherId" placeholder="请选择">
                  <el-option
                    v-for="item in teacherList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <!-- 安排课表 -->
    <el-card class="mt20">
      <div slot="header" class="clearfix">
        <span>安排课表</span>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="单次排课" name="single"></el-tab-pane>
          <el-tab-pane label="循环排课" name="first"></el-tab-pane>
          <!-- 日历排课 -->
          <el-tab-pane v-if="false" label="日历排课" name="second"></el-tab-pane>
        </el-tabs>

        <el-form v-if="activeName == 'single'" label-width="160px" :rules="rules" ref="singleForm" :model="fromData">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="开课日期" prop="startDates">
                <el-date-picker
                  v-model="fromData.startDates"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24" v-for="(time, index) in singleClassTimes" :key="time.key">
            <el-col :span="24">
              <el-form-item
                :label="'上课时间 ' + (index + 1)"
                :prop="'singleTime' + index"
                :rules="{ required: true, message: '请选择上课时间', trigger: 'change' }">
                <el-time-picker
                  style="width: 120px;"
                  v-model="time.beginTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  @change="changeSingleEndTime(time, $event)"
                  placeholder="开始时间">
                </el-time-picker>
                至
                <el-time-picker
                  style="width: 120px;"
                  v-model="time.endTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="结束时间">
                </el-time-picker>
                <el-button
                  v-if="singleClassTimes.length > 1"
                  @click="removeSingleTime(index)"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  style="margin-left: 10px;"
                  size="mini"></el-button>
                <el-button v-if="index == singleClassTimes.length -1" @click="addSingleTime" type="primary" icon="el-icon-plus" style="margin-left:5px;">添加时间段</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-form v-if="activeName == 'first'" label-width="160px" :model="fromData">
          <div v-for="(schedule, sIndex) in loopSchedules" :key="'loop-'+sIndex" class="schedule-item">
            <el-row :gutter="24" class="custom-flex-row">
              <el-col :span="8">
                <el-form-item label="开课日期" :prop="'loopSchedules['+sIndex+'].startDate'">
                  <el-date-picker
                    v-model="schedule.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="重复方式">
                  <el-select v-model="schedule.loopType" placeholder="请选择">
                    <el-option
                      v-for="item in loopTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button v-if="loopSchedules.length > 1" @click="removeSchedule(sIndex, 'loop')"
                           type="danger" icon="el-icon-delete">
                  删除
                </el-button>
              </el-col>
              <el-col :span="5">
                <el-button @click="addNewSchedule('loop')" type="primary" icon="el-icon-plus">
                  添加开课日期
                </el-button>
              </el-col>
            </el-row>
            <div v-for="(time, tIndex) in schedule.timeSlots" :key="'loop-time-'+tIndex">
              <el-form-item :label="'上课时间 ' + (tIndex + 1)">
                <!-- 使用 Flex 布局容器 -->
                <div style="display: flex; align-items: center; gap: 10px;">
                  <!-- 开始时间选择器 -->
                  <el-time-picker
                    v-model="time.beginTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    @change="changeEndTime(time, $event)"
                    style="width: 120px;"
                    placeholder="开始时间">
                  </el-time-picker>

                  <!-- “至”字 -->
                  <span style="flex-shrink: 0;">至</span>

                  <!-- 结束时间选择器 -->
                  <el-time-picker
                    v-model="time.endTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    style="width: 120px;"
                    placeholder="结束时间">
                  </el-time-picker>

                  <!-- 删除按钮 -->
                  <el-button
                    v-if="schedule.timeSlots.length > 1"
                    @click="removeTimeSlot(sIndex, tIndex, 'loop')"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    style="flex-shrink: 0;">
                  </el-button>
                  <el-button @click="addTimeSlot(sIndex, 'loop')" type="primary"
                             icon="el-icon-plus" size="small">添加时间段</el-button>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <el-form v-if="activeName == 'second'" label-width="160px" :model="fromData">
          <div v-for="(schedule, sIndex) in calendarSchedules" :key="'calendar-'+sIndex" class="schedule-item">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="开课日期">
                  <el-date-picker
                    v-model="schedule.startDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-button v-if="calendarSchedules.length > 1" @click="removeSchedule(sIndex, 'calendar')"
                           type="danger" icon="el-icon-delete" style="margin-top: 30px;">
                  删除
                </el-button>
              </el-col>
            </el-row>

            <div v-for="(time, tIndex) in schedule.timeSlots" :key="'calendar-time-'+tIndex">
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item :label="'上课时间 ' + (tIndex + 1)">
                    <el-time-picker
                      v-model="time.beginTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      @change="changeEndTime(time, $event)"
                      placeholder="开始时间">
                    </el-time-picker>
                    至
                    <el-time-picker
                      v-model="time.endTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      placeholder="结束时间">
                    </el-time-picker>
                    <el-button v-if="schedule.timeSlots.length > 1"
                               @click="removeTimeSlot(sIndex, tIndex, 'calendar')"
                               type="danger" icon="el-icon-delete" circle
                               style="margin-left: 10px;" size="mini">
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <el-button @click="addTimeSlot(sIndex, 'calendar')" type="primary"
                       icon="el-icon-plus" size="small">
              添加时间段
            </el-button>

            <el-divider></el-divider>
          </div>

          <el-button @click="addNewSchedule('calendar')" type="primary" icon="el-icon-plus">
            添加开课日期
          </el-button>
        </el-form>
      </div>
    </el-card>

    <div class="footer-nav">
      <el-button type="primary" @click="submitForm('fromData')">确定</el-button>
      <el-button @click="resetForm('fromData')">取消</el-button>
    </div>

    <!-- 新建课程的弹窗 -->
    <el-dialog
      title="新建1对1课程"
      :visible.sync="courseModalVisible"
      width="800px"
      :close-on-click-modal="false">
      <el-form label-width="160px" :rules="courseRules" ref="courseForm" :model="courseForm" class="course-form">
        <div>
          <h5 class="">基本信息</h5>
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选择课程类型" prop="type">
              <div>
                <el-radio v-model="courseForm.type" :label="1" value="1">1对1</el-radio>
              </div>
              <span class="wran_tips">(仅支持创建1对1类型)</span>
            </el-form-item>
          </el-col>
          <!-- 新增课程状态选择 -->
          <el-col :span="12">
            <el-form-item label="课程状态" prop="openStatus">
              <el-radio v-model="courseForm.openStatus" :label="1" value="1">开启</el-radio>
              <el-radio v-model="courseForm.openStatus" :label="0" value="0">关闭</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="课程名称" prop="name">
              <el-input placeholder="不超过50个字符" maxlength="50" v-model="courseForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单课时长" prop="longTimeOf">
              <el-input placeholder="单课时长为5的倍数" v-model="courseForm.longTimeOf" suffix="分钟">
                <template>
                  <slot slot="suffix" class="input-slot">分钟</slot>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="薪酬基数" label-position="top" prop="basicSalary">
              <el-input v-model="courseForm.basicSalary"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="累计增加基数" label-position="top" prop="addToSalary">
              <el-input v-model="courseForm.addToSalary"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">

          <el-col :span="12">
            <el-form-item label="授课老师" prop="teacherId">
              <el-select v-model="courseForm.teacherId" placeholder="请选择">
                <el-option
                  v-for="item in teacherListAll"
                  :key="item.id"
                  :label="item.realname + '（' + item.phone + '）'"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程详情介绍" prop="description">
              <el-input type="textarea" v-model="courseForm.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="courseModalVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCourseForm" :loading="courseSubmitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id: '',
        fromData: {
          beginTime: '',
          className: '',
          classRoom: '',
          courseId: '',
          endTime: '',
          longTimeOf: '',
          loopType: 2,
          deductType: 1,
          deductTimes: 1,
          startDates: '',
          startDateStr: '',
          timeStr: '',
          type: 1, // 默认循环排课
          time: ['00:00:00', '23:59:59'],
          teacherId: ''
        },
        step: '00:45',
        loopSchedules: [
          {
            startDate: '', // 开课日期
            loopType: 2,   // 重复方式
            timeSlots: [   // 时间段数组
              { beginTime: '09:00', endTime: '10:30' }
            ]
          }
        ],
        // 日历排课数据
        calendarSchedules: [
          {
            startDate: '', // 开课日期
            timeSlots: [   // 时间段数组
              { beginTime: '', endTime: '' }
            ]
          }
        ],
        activeName: 'first', // 默认选中循环排课
        // ========== 核心修改：新增loop_type=5和6 ==========
        loopTypeList: [
          {
            value: 1,
            label: '隔周重复'
          },
          {
            value: 2,
            label: '每周重复'
          },
          {
            value: 3,
            label: '隔日重复'
          },
          {
            value: 4,
            label: '每日重复'
          },
          {
            value: 5,
            label: '一三五重复'
          },
          {
            value: 6,
            label: '二四六重复'
          }
        ],
        // ========== 核心修改结束 ==========
        // 单次排课的时间段列表
        singleClassTimes: [
          { beginTime: '', endTime: '', key: '' }
        ],
        allList: [],
        // 课程列表
        courseList: [],
        teacherList: [],
        deductTypeList: [
          {
            label: '次数',
            value: 1
          },
          {
            label: '时长（小时）',
            value: 2
          }
        ],
        // 校验规则（修复：移除不存在的maxNum校验）
        rules: {
          classRoom: [
            { required: true, message: '请输入上课教室', trigger: 'blur' }
          ],
          courseId: [
            { required: true, message: '请选择所属课程', trigger: 'change' }
          ],
          longTimeOf: [
            { required: true, message: '请输入单课时长', trigger: 'blur' }
          ],
          startDates: [
            { required: true, message: '请选择开课日期', trigger: 'change' }
          ]
        },
        isEdit: false,

        // 新建课程弹窗相关数据（1对1专属）
        courseModalVisible: false, // 课程弹窗显示状态
        courseSubmitting: false, // 防止重复提交
        courseForm: { // 新建课程表单数据
          type: 1, // 默认1对1类型
          name: '',
          setMealId: '',
          longTimeOf: '',
          teacherId: '',
          basicSalary: '',
          addToSalary: '',
          description: '',
          openStatus: 1 // 默认开启状态
        },
        courseRules: { // 新建课程校验规则
          type: [
            { required: true, message: '请选择课程类型', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入课程名称', trigger: 'blur' }
          ],
          teacherId: [
            { required: true, message: '请选择授课老师', trigger: 'blur' }
          ],
          longTimeOf: [
            { required: true, message: '请输入单课时长', trigger: 'blur' }
          ]
        },
        suitList: [], // 套餐列表（新建课程用）
        teacherListAll: [] // 所有老师列表（新建课程用）
      };
    },
    created() {
      this.initDate();
      this.getCourseList();
      this.getSetMealList(); // 加载套餐列表
      this.getTeacherListAll(); // 加载所有老师
    },
    methods: {
      initDate() {
        let params = this.$route.params;
        if (params && params.type == 'edit') {
          this.fromData = params.recordDate;
          this.fromData.teacherId = this.fromData.courseId;
          this.isEdit = true;
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addClass();
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        // 修复：取消后返回1对1班级列表，不是学生列表
        this.$router.push("/oneByOneClassList");
      },
      // tab切换
      handleClick(tab, event) {
        this.tabName = tab.name;
        if (tab.name == 'single') {
          this.fromData.type = 0;
        } else if (tab.name == 'first') {
          this.fromData.type = 1;
        }
        this.initDate();
      },
      addSingleTime() {
        this.singleClassTimes.push({
          beginTime: '',
          endTime: '',
          key: Date.now() + this.singleClassTimes.length
        });
      },

      // 删除单次排课时间段
      removeSingleTime(index) {
        this.singleClassTimes.splice(index, 1);
      },

      // 修改单次排课结束时间
      changeSingleEndTime(timeItem, beginTime) {
        if (!beginTime || !this.fromData.longTimeOf) return;

        const [hours, minutes] = beginTime.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes + Number(this.fromData.longTimeOf);

        const endHours = Math.floor(totalMinutes / 60) % 24;
        const endMinutes = totalMinutes % 60;

        timeItem.endTime = `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;
      },

      // 修改循环/日历排课结束时间
      changeEndTime(timeItem, beginTime) {
        if (!beginTime || !this.fromData.longTimeOf) return;
        this.changeSingleEndTime(timeItem, beginTime);
      },

      // 添加新的开课日期配置
      addNewSchedule(type) {
        const newSchedule = {
          startDate: '',
          timeSlots: [{ beginTime: '', endTime: '' }]
        };
        if (type === 'loop') {
          newSchedule.loopType = 2;
          this.$set(this.loopSchedules, this.loopSchedules.length, newSchedule);
        } else if (type === 'calendar') {
          this.$set(this.calendarSchedules, this.calendarSchedules.length, newSchedule);
        }
      },

      // 删除开课日期配置
      removeSchedule(index, type) {
        if (type === 'loop') {
          this.loopSchedules.splice(index, 1);
        } else if (type === 'calendar') {
          this.calendarSchedules.splice(index, 1);
        }
      },

      // 为特定开课日期添加时间段
      addTimeSlot(scheduleIndex, type) {
        const newTimeSlot = { beginTime: '', endTime: '' };
        if (type === 'loop') {
          this.$set(this.loopSchedules[scheduleIndex].timeSlots, this.loopSchedules[scheduleIndex].timeSlots.length, newTimeSlot);
        } else if (type === 'calendar') {
          this.$set(this.calendarSchedules[scheduleIndex].timeSlots, this.calendarSchedules[scheduleIndex].timeSlots.length, newTimeSlot);
        }
      },

      // 删除特定时间段
      removeTimeSlot(scheduleIndex, timeIndex, type) {
        if (type === 'loop') {
          this.loopSchedules[scheduleIndex].timeSlots.splice(timeIndex, 1);
        } else if (type === 'calendar') {
          this.calendarSchedules[scheduleIndex].timeSlots.splice(timeIndex, 1);
        }
      },

      // 处理班级表单提交（增加异常捕获）
      async addClass() {
        // 构建时间字符串
        if (this.activeName === 'single') {
          this.fromData.timeStr = this.singleClassTimes
            .map(time => `${time.beginTime},${time.endTime}`)
            .join(';');
          this.fromData.type = 0;
        } else if (this.activeName === 'first') {
          this.fromData.timeStr = this.loopSchedules.map(schedule => {
            const times = schedule.timeSlots.map(time =>
              `${time.beginTime},${time.endTime}`).join(';');
            // 新增的loop_type=5/6会正常参与时间字符串构建
            return `${schedule.startDate}|${schedule.loopType}|${times}`;
          }).join('#');
          this.fromData.type = 1;
        } else {
          this.fromData.timeStr = this.calendarSchedules.map(schedule => {
            const times = schedule.timeSlots.map(time =>
              `${time.beginTime},${time.endTime}`).join(';');
            return `${schedule.startDate}|${times}`;
          }).join('#');
          this.fromData.type = 2;
        }

        let url = this.isEdit ? '/ea/student/classOneOnOne/edit' : '/ea/student/classOneOnOne/add';
        try {
          const { data: res } = await this.$http.post(url, this.fromData);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.$message.success(this.isEdit ? '编辑成功' : "新增班级成功");
          this.$router.push({ path: '/oneByOneClassList' });
        } catch (e) {
          console.error("提交1对1班级失败：", e);
          this.$message.error("操作失败，请重试");
        }
      },

      // 获取课程对应的老师列表（完善自动选中逻辑 + 新增：自动填充班级名称）
      getTeacher(id) {
        this.teacherList = []; // 清空原有列表
        if (!id) return;

        // 查找对应课程信息
        const currentCourse = this.allList.find(e => e.id == id);
        if (currentCourse) {
          // 填充老师列表
          this.teacherList.push({
            label: currentCourse.teacherName,
            value: currentCourse.id
          });

          // 自动选中第一个老师（如果有）
          if (this.teacherList.length > 0 && !this.fromData.teacherId) {
            this.fromData.teacherId = this.teacherList[0].value;
          }

          // 新增：仅在新增场景下（非编辑）自动填充班级名称
          if (!this.isEdit) {
            this.fromData.className = currentCourse.name;
          }
        }
      },

      // 获取所有课程信息（1对1类型）
      async getCourseList() {
        try {
          const { data: res } = await this.$http.get(`/ea/student/course/getCourseList?type=1`);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.allList = res.result?.courses || [];
          this.courseList = []; // 清空原有列表
          this.allList.forEach(e => {
            this.courseList.push({
              value: e.id,
              label: e.name
            });
          });
          this.getTeacher(this.fromData.courseId);
        } catch (e) {
          console.error("获取1对1课程列表失败：", e);
          this.$message.error("加载课程列表失败");
        }
      },

      // 打开新建课程弹窗
      openCourseModal() {
        // 重置表单
        this.courseForm = {
          type: 1, // 默认1对1
          name: '',
          setMealId: '',
          longTimeOf: '',
          teacherId: '',
          basicSalary: '',
          addToSalary: '',
          description: '',
          openStatus: 1 // 默认开启
        };
        // 重置表单校验状态
        this.$nextTick(() => {
          if (this.$refs.courseForm) {
            this.$refs.courseForm.resetFields();
          }
        });
        this.courseModalVisible = true;
      },

      // 获取套餐列表（新建课程用）
      async getSetMealList() {
        try {
          const { data: res } = await this.$http.get(`/ea/student/setMeal/getSetMealList`);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.suitList = res.result || [];
        } catch (e) {
          console.error("获取套餐列表失败：", e);
          this.$message.error("加载套餐列表失败");
        }
      },

      // 获取所有老师列表（新建课程用）
      async getTeacherListAll() {
        try {
          const { data: res } = await this.$http.get(`/ea/sys/user/getTeacherList`);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.teacherListAll = res.result || [];
        } catch (e) {
          console.error("获取老师列表失败：", e);
          this.$message.error("加载老师列表失败");
        }
      },

      // 提交新建课程表单（新增：自动填充班级名称）
      async submitCourseForm() {
        if (this.courseSubmitting) return; // 防止重复提交
        this.courseSubmitting = true;

        try {
          // 表单校验
          const valid = await new Promise((resolve) => {
            this.$refs.courseForm.validate((valid) => resolve(valid));
          });

          if (!valid) {
            this.courseSubmitting = false;
            return;
          }

          // 调用新建课程接口
          const { data: res } = await this.$http.post("/ea/student/course/add", this.courseForm);

          // 严格判断接口返回
          if (res && res.code === 200) {
            this.$message.success("新增1对1课程成功");
            this.courseModalVisible = false;

            // 刷新课程列表
            await this.getCourseList();

            // 自动选中新建的课程 + 新增：自动填充班级名称
            this.$nextTick(() => {
              const newCourseId = res.result?.id;
              if (newCourseId) {
                this.fromData.courseId = newCourseId;
                if (this.$refs.courseSelect) {
                  this.$refs.courseSelect.selectedValue = newCourseId;
                }

                // 查找新建的课程名称并填充到班级名称
                const newCourse = this.allList.find(e => e.id == newCourseId);
                if (!this.isEdit) {
                  this.fromData.className = newCourse.name;
                }

                this.getTeacher(newCourseId);
              }
            });
          } else {
            this.$message.error(res?.message || "新增课程失败");
          }
        } catch (e) {
          console.error("新建1对1课程异常：", e);
          this.$message.error("新增课程失败，请检查网络或联系管理员");
        } finally {
          this.courseSubmitting = false; // 重置提交状态
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  // 关键修复：下拉框+按钮布局样式（强制生效）
  .course-form-item {
    /deep/ .el-form-item__content {
      display: flex;
      align-items: center;
    }
  }

  .course-select-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;

    .el-select {
      flex: 1; // 让下拉框占满剩余空间（关键修复）
    }

    .el-button {
      width: 80px; // 固定按钮宽度，防止换行
      white-space: nowrap;
    }
  }

  // 新建课程弹窗样式优化
  .course-form {
    padding: 20px 0;

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-col {
      padding: 0 8px;
    }
  }

  // 提示文字样式
  .wran_tips {
    color: red;
    font-size: 12px;
    margin-top: 4px;
    display: block;
  }

  // 排课相关样式
  .time-slot-item {
    margin-bottom: 15px;
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    position: relative;
  }

  .remove-time-btn {
    position: absolute;
    right: -10px;
    top: -10px;
  }

  .custom-flex-row {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-left: -12px;
    margin-right: -12px;

    .el-col {
      flex-shrink: 0;
    }
  }

  .schedule-item {
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 16px;

    &:last-child {
      border-bottom: none;
    }
  }

  // 通用样式
  /deep/ .el-upload__input {
    display: none;
  }

  .mt20 {
    margin-top: 20px;
  }
</style>
